var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u062F\\u0634\\u0628\\u0648\\u0631\\u062F",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M6.25,4h6A2.25,2.25,0,0,1,14.5,6.25v1.5A2.25,2.25,0,0,1,12.25,10h-6A2.25,2.25,0,0,1,4,7.75V6.25A2.25,2.25,0,0,1,6.25,4Zm13.5,18h6A2.25,2.25,0,0,1,28,24.25v1.5A2.25,2.25,0,0,1,25.75,28h-6a2.25,2.25,0,0,1-2.25-2.25v-1.5A2.25,2.25,0,0,1,19.75,22Z",
    fill: "#333",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-2",
    "data-name": "Combined-Shape",
    d: "M6.25,13h6a2.25,2.25,0,0,1,2.25,2.25v10.5A2.25,2.25,0,0,1,12.25,28h-6A2.25,2.25,0,0,1,4,25.75V15.25A2.25,2.25,0,0,1,6.25,13Zm13.5-9h6A2.25,2.25,0,0,1,28,6.25v10.5A2.25,2.25,0,0,1,25.75,19h-6a2.25,2.25,0,0,1-2.25-2.25V6.25A2.25,2.25,0,0,1,19.75,4Z",
    fill: "#333",
    fillRule: "evenodd",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c318541be4db3cc402a66f8ddae730d5.svg";
export { ForwardRef as ReactComponent };